import { makeStyles } from "@mui/styles";

const successColor = "#2e7d32";
const successBackground = "#e8f5e9";
const mutedText = "#8a8a8a";
const cardBorder = "1px solid #e5e2e5";

const useStyles: any = makeStyles(() => ({
  dialogPaper: {
    maxWidth: 680
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
    padding: "0 16px 0 24px"
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 10
  },
  successBadge: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: successBackground,
    color: successColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  successIcon: {
    fontSize: 20
  },
  subtitle: {
    color: mutedText,
    padding: "10px 24px 2px 28px"
  },
  content: {
    paddingTop: 4
  },
  summaryCard: {
    backgroundColor: "#f6f5f6",
    borderRadius: 8,
    padding: "6px 16px"
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minHeight: 36
  },
  label: {
    color: mutedText,
    width: 90,
    flexShrink: 0
  },
  value: {
    flex: 1,
    fontWeight: 500,
    wordBreak: "break-word"
  },
  password: {
    fontFamily: "monospace",
    fontSize: 15,
    letterSpacing: 0.5
  },
  newChip: {
    height: 20,
    marginLeft: 8,
    fontSize: 11,
    fontWeight: 600,
    backgroundColor: successBackground,
    color: successColor
  },
  credentialsCard: {
    marginTop: 16,
    border: cardBorder,
    borderRadius: 8,
    overflow: "hidden"
  },
  credentialsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 8px 6px 16px",
    backgroundColor: "#fbfafb",
    borderBottom: cardBorder
  },
  credentialsTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: "#421a40"
  },
  credentialsBody: {
    padding: "4px 8px 4px 16px"
  },
  warning: {
    margin: "4px 16px 12px",
    padding: "0 12px",
    borderRadius: 6,
    border: "none"
  },
  copiedIcon: {
    color: successColor
  },
  actions: {
    padding: "8px 24px 20px"
  },
  actionButton: {
    minWidth: 120
  }
}));

export default useStyles;
